import { config } from '@/_helpers'
import axios from "axios"

let axiosHeaders = { 'Content-Type': 'application/json' }

export const $_gas_server = axios.create({
  baseURL: config.syncUrlShort,
  headers: axiosHeaders
})
export const $_sync_server = axios.create({
  baseURL: config.gasUrl,
  headers: axiosHeaders
})
export const $_web_server = axios.create({
  baseURL: config.apiUrl,
  headers: axiosHeaders
})

export const versionService = {
    gasV,
    syncV,
    webV,
    frontV
}

function gasV () {
    return $_gas_server.get("version/" + getRandomInt()).then(response => response.data)
}

function syncV () {
  return $_sync_server.get("version/" + getRandomInt()).then(response => response.data)
}

function webV () {
  return $_web_server.get("version/" + getRandomInt()).then(response => response.data)
}

function frontV () {
  if (process.env.NODE_ENV === 'production') {
    return axios.get(config.host + "version?" + getRandomInt()).then(response => response.data.split('\n'))
  }
  return new Promise((resolve) => resolve(["local", "current"]))
}

function getRandomInt() {
  return Math.floor(Math.random() * Math.floor(9999999999));
}